import { tenantIDAtom } from "atoms/GlobalAtoms";
import { useNavigate } from "react-router-dom";
import { useAtomValue } from "jotai";
import { Dropdown } from "rsuite";

import DropdownOptionWithIcon from "components/Menus/DropdownOptionWithIcon";
import DropdownMenuDivider from "components/Menus/DropdownMenuDivider";
import useLogout from "api/api-hooks/auth/useLogout";
import useUser from "api/api-hooks/auth/useUser";
import Constants from "utils/Constants";

const NavbarAccountOptions = ({ onClose }) => {
  const { user } = useUser();
  const navigate = useNavigate();
  const { logout } = useLogout();
  const tenantID = useAtomValue(tenantIDAtom);

  return (
    <Dropdown.Menu>
      <DropdownOptionWithIcon
        name="Account Settings"
        onClick={() => {
          navigate(
            tenantID
              ? `/clouds/${tenantID}/settings/account/profile`
              : "/account/profile"
          );
          onClose();
        }}
        icon="mdi mdi-account-outline"
      />
      <DropdownOptionWithIcon
        name="My Tags"
        onClick={() => {
          navigate(`/clouds/${tenantID}/settings/tags/user`);
          onClose();
        }}
        icon="mdi mdi-tag-outline"
      />
      <DropdownOptionWithIcon
        name="Support"
        onClick={() => {
          window.open("mailto:support@growthcloud.com");
          onClose();
        }}
        icon="mdi mdi-lifebuoy"
      />
      <DropdownMenuDivider />
      <DropdownOptionWithIcon
        name="Logout"
        onClick={logout}
        icon="mdi mdi-logout-variant"
      />
    </Dropdown.Menu>
  );
};

export default NavbarAccountOptions;

export function userHasSupportalPerms(user) {
  if (!user || !Array.isArray(user.Tenants)) return false;

  // Check for Global Permission / Tenant Ownership.
  return Boolean(
    user.Tenants.find((t) => t?.TenantID === Constants.SUP_CLOUD_ID)
  );
}
